import React from 'react';
import { Empty, List, Spin } from 'antd';
import useInformations from '../../queries/useInformations';
import Item from './Item';
import { useSelector } from 'react-redux';
import { selectedInfoSelector } from '../../store/selectors';

const InfoList = ({ classname, queryParams }) => {
  const { data: informations, isFetching } = useInformations(queryParams);

  const selectedInfo = useSelector(selectedInfoSelector);

  return (
    <div className={classname}>
      <Spin
        style={{ minHeight: 300 }}
        size="large"
        spinning={isFetching}
        tip="Загрузка..."
        delay={100}
      >
        {informations?.length ? (
          <List
            itemLayout="vertical"
            dataSource={informations || []}
            className="informations-list"
            renderItem={(item) => (
              <Item item={item} selected={selectedInfo?.id === item.id} />
            )}
          />
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Не найдено"
          />
        )}
      </Spin>
    </div>
  );
};

export default InfoList;
